import {z} from "zod"

import {post} from "../http"

export const ConfigurePaymentMethodV2Schema = z.strictObject({
	PaymentArrangementID: z.string(),
	PaymentMethodID: z.string(),
	SetupIntentID: z.string(),
	ProviderRawData: z.string(),
})

type ConfigurePaymentMethodV2Params = z.infer<typeof ConfigurePaymentMethodV2Schema>

export async function configurePaymentMethodV2({
	PaymentArrangementID,
	PaymentMethodID,
	SetupIntentID,
	ProviderRawData,
}: ConfigurePaymentMethodV2Params) {
	return await post(`/app/payment-arrangements/${PaymentArrangementID}/configure-payment-method-v2`, {
		PaymentMethodID,
		ProviderSetupID: SetupIntentID,
		ProviderRawEvent: ProviderRawData,
	})
}
